import { twMerge } from "tailwind-merge";
import {
  PasswordRequirementsBase,
  type PasswordRequirementsBaseProps,
} from "@core/features/auth";
import { RequirementCheck } from "@themes/pollinator/ui/RequirementCheck";

export type Props = Omit<PasswordRequirementsBaseProps, "renderRequirement">;

export function AuthPasswordRequirements({
  password,
  isTooShortError,
  isInvalidStringError,
  layout,
  className,
}: Props) {
  return (
    <PasswordRequirementsBase
      password={password}
      isTooShortError={isTooShortError}
      isInvalidStringError={isInvalidStringError}
      layout={layout}
      className={twMerge(
        layout === "horizontal" &&
          "relative flex flex-col gap-1 transition-opacity duration-100 md:flex-row md:justify-end",
        layout === "horizontal" && "flex flex-col gap-2 md:flex-col p-1",
        className
      )}
      renderRequirement={(requirement) => (
        <div
          key={requirement.id}
          className={twMerge(
            "flex flex-col gap-2",
            layout === "horizontal" &&
              "relative flex w-full flex-col gap-4 md:w-full md:ml-48 md:pl-6"
          )}
        >
          <RequirementCheck
            isMet={requirement.isMet}
            message={requirement.message}
            captionClassName={twMerge(requirement.hasError && "text-error")}
          />
        </div>
      )}
    />
  );
}

export default AuthPasswordRequirements;

